<template>
    <div class="footer" :style="'height:4.9rem;'">
      <div class="footer-intro">
        <div class="footer-left">
          <img class="logo" alt="浩润集团" src="../assets/logo.png">
          <div class="nav" @click="chooseHandler">
            <span id=0>首页&nbsp; |</span>
            <span id=1> &nbsp;关于浩润&nbsp; |</span>
            <span id=2> &nbsp;业务布局&nbsp; |</span>
            <span id=3> &nbsp;产品中心&nbsp; |</span>
            <span id=4> &nbsp;新闻资讯&nbsp; |</span>
            <span id=5> &nbsp;人才招聘&nbsp; |</span>
            <span id=6> &nbsp;联系我们 </span>
          </div>
          <div>邮箱：hrtz@haorungroup.cn</div>
        </div>
        <div class="footer-right">
          <div class="go-top" @click="debounceGoTop">返回顶部 ↑</div>
          <div class="footer-offcial">
            <div class="offcial-msg">
              <div class="offcial-img">
                <img class="Qrcode" alt="浩润集团" src="../assets/Qrcode.jpg">
              </div>
              <span>集团公众号</span>
            </div>
            <div class="offcial-msg">
              <div class="offcial-img">
                <img class="dongLogo" alt="浩润集团" src="../assets/jixiangfu.jpg">
              </div>
              <span><a class="link" href="https://mall.jd.com/index-11690301.html" target=“_blank”>京东旗舰店</a></span>
            </div>
            <div class="offcial-msg" style="margin-left: 0.1rem;">
              <div class="offcial-img">
                <img class="dongLogo" alt="浩润集团" src="../assets/haoze.jpg">
              </div>
              <span><a class="link" href="https://mall.jd.com/index-11930770.html" target=“_blank”>京东旗舰店</a></span>
            </div>
            <div class="offcial-msg" style="margin-left: 0.1rem;">
              <div class="offcial-img">
                <img class="tianmao" alt="浩润集团" src="../assets/tianmaoQrcode.png">
              </div>
              <span><a class="link" href="https://huahaihenghuijl.tmall.com/index.htm?spm=a1z10.1-b-s.w5002-24218119994.2.12016d2brGuG2Y" target=“_blank”>天猫旗舰店</a></span>
            </div>
          </div>
        </div>
      </div>
      <div class="footer-trademark">版权所有Copyright © 2025 浩润控股投资（深圳）有限公司 <a href="https://beian.miit.gov.cn/" target="_blank">粤ICP备2022108677号</a></div>
    </div>
</template>

<script>
import { defineComponent, ref, reactive } from 'vue'
import router from '@/router/index.js'
import { debounce } from '@/utils/tools'

export default defineComponent({
  name: 'TopNav',
  setup () {
    // const footerHeight = ref((document.documentElement.clientWidth * 0.255).toFixed(2) + 'px')
    const state = reactive({
      path: [
        '/',
        '/about',
        '/business',
        '/product',
        '/news-information',
        '/recruitment',
        '/contact'
      ]
    })
    const indexId = ref('0')

    function chooseHandler (e) {
      if (indexId.value === e.target.id) {
        window.location.href = window.origin + state.path[e.target.id]
      } else {
        indexId.value = e.target.id
        switch (e.target.id) {
          case '0':
            router.push('/')
            break
          case '1':
            router.push('/about')
            break
          case '2':
            router.push('/business')
            break
          case '3':
            router.push('/product')
            break
          case '4':
            router.push('/news-information')
            break
          case '5':
            router.push('/recruitment')
            break
          case '6':
            router.push('/contact')
            break
          default:
            break
        }
      }
    }
    // 防抖
    function debounceGoTop () {
      debounce(goTop(), 1000)
    }

    function goTop () {
      // window.scrollTo(0, 0)
      let top = document.documentElement.scrollTop || document.body.scrollTop
      // 实现滚动效果
      const timeTop = setInterval(() => {
        document.body.scrollTop = document.documentElement.scrollTop = top -= 50
        if (top <= 0) {
          clearInterval(timeTop)
        }
      }, 10)
    }

    return {
      indexId,
      // footerHeight,
      chooseHandler,
      debounceGoTop
    }
  }
})
</script>

<style lang="scss" scoped>
@mixin wh($width, $height) {
    width: $width;
    height: $height;
}
@mixin font($size, $weight, $color) {
    font-size: $size;
    color: $color;
    font-weight: $weight;
}
@mixin bg($url) {
    background-image: url($url);
    background-repeat: no-repeat;
    background-size: 100% 100%;
}
a{
  text-decoration:none;
}
.footer {
    width: 100%;
    @include bg('~@/assets/footer1.png');
    @include font(0.18rem, 500,#fff);
    .footer-intro {
      display: flex;
      justify-content: space-between;
      margin: 0 3.2rem;
      padding-top: 1.85rem;
      .footer-left{
        text-align: left;
        .logo {
          @include wh(1.5rem,0.6rem);
        }
        .nav {
          position: relative;
          z-index: 2;
          white-space: nowrap;
          margin: 0.23rem 0;
          & span{
            cursor:pointer;
          }
        }
      }
      .footer-right {
        text-align: right;
        .go-top {
          @include font(0.18rem,400,#ffffff);
          margin-bottom: 0.34rem;
          cursor:pointer;/*鼠标变小手*/
        }
        .footer-offcial{
          display: flex;
          .offcial-msg:nth-child(2){
            margin-left: 0.1rem;
          }
          .offcial-msg{
            & span{
              font-size: 0.2rem;
              .link {
                color: #ffffff;
              }
            }
            .offcial-img{
              @include wh(1rem,1rem);
              background: #ffffff;
              border: 0.01rem solid #707070;
              border-radius: 0.1rem;
              display: flex;
              justify-content: center;
              align-items: center;
              margin-bottom: 0.1rem;
              .Qrcode {
                @include wh(0.89rem,0.89rem);
              }
              .dongLogo {
                @include wh(0.8rem,0.8rem);
              }
              .tianmao {
                @include wh(1rem, 1rem);
                border-radius: 0.1rem;
              }
            }
          }
        }
      }
    }
    .footer-trademark {
      margin-top: 0.5rem;
      text-align: center;
      font-size: 0.15rem;
    }
}
</style>
